<template>
  <div class="item-wrap">
    <div class="title">
      <span class="text"> <slot name="title" /></span>
      <slot name="status" />
    </div>
    <slot name="content" />
    <div class="button pointer" @click="handleGoPage(id)">活动详情</div>
  </div>
</template>

<script>
export default {
  name: 'PolicyItem',
  props: {
    id: {
      required: true,
      type: String,
    },
  },
  methods: {
    // goToDetail(){
    //   this.$router.push('/activity-detail')
    // },
    handleGoPage(id) {
      this.$router.push('/activity-detail/' + id)
    },
  },
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
